export default __webpack_public_path__ + "static/media/product-tour[intro].2a040cd4.png";